module.exports = __webpack_public_path__ + "static/media/Step 10e-Lookout.a1def203.png";